export enum OfferUnavailableReason {
  SOLD_OUT = 'SOLD_OUT',
  CAPACITY_EXCEEDED = 'CAPACITY_EXCEEDED',
  DATE_UNAVAILABLE = 'DATE_UNAVAILABLE',
  NUM_NIGHTS_UNSUPPORTED = 'NUM_OF_NIGHTS_UNSUPPORTED',
  NO_PRICES_FOUND = 'NO_PRICES_FOUND',
  UNAVAILABLE_FOR_FILTERS_SELECTED = 'UNAVAILABLE_FOR_FILTERS_SELECTED',
  FLIGHT_CLASS_UNAVAILABLE = 'FLIGHT_CLASS_UNAVAILABLE',
}

export const STORE_MAP_PAGE_ZOOM = '0.55'
